import {
 basePath
} from '../common/path'

const base = basePath.concat('/absenteeism')

const paths = {
    totalRecorded: base.concat('/total-recorded')
}
export { paths }